import React from "react";
import ContactUs from "../components/ContactUs";

const ContactUsPage = () => {
  return <ContactUs />;
};

export default ContactUsPage;
